"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 40px;\n  border: none;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  background: ", ";\n  font-family: ", ";\n  max-width: 400px;\n  box-sizing: border-box;\n  border: none;\n  display: flex;\n\n  input.name {\n    text-indent: 12px;\n    color: ", ";\n    font-size: 16px;\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    padding-right: 12px;\n    border: 1.5px solid transparent;\n    height: 40px;\n    background-color: transparent;\n    box-sizing: border-box;\n  }\n\n  button {\n    height: 40px;\n    width: 40px;\n    border-color: transparent;\n    color: ", ";\n    background: ", ";\n    font-size: 18px;\n    line-height: 20px;\n    cursor: pointer;\n\n    &:not(:disabled) {\n      &:hover {\n        background: ", ";\n        color: ", ";\n      }\n    }\n  }\n\n  &.disabled {\n    input.name {\n      color: ", ";\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    button:disabled {\n      background: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n  }\n\n  &.invalid {\n    input.name {\n      background: ", ";\n      border: 1.5px solid ", ";\n      color: ", ";\n    }\n\n    button {\n      background: ", ";\n      border: 1.5px solid ", ";\n      /* color: ", ";\n      background: ", ";\n      color: ", ";\n      cursor: not-allowed; */\n    }\n  }\n"], ["\n  height: 40px;\n  border: none;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  background: ", ";\n  font-family: ", ";\n  max-width: 400px;\n  box-sizing: border-box;\n  border: none;\n  display: flex;\n\n  input.name {\n    text-indent: 12px;\n    color: ", ";\n    font-size: 16px;\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    padding-right: 12px;\n    border: 1.5px solid transparent;\n    height: 40px;\n    background-color: transparent;\n    box-sizing: border-box;\n  }\n\n  button {\n    height: 40px;\n    width: 40px;\n    border-color: transparent;\n    color: ", ";\n    background: ", ";\n    font-size: 18px;\n    line-height: 20px;\n    cursor: pointer;\n\n    &:not(:disabled) {\n      &:hover {\n        background: ", ";\n        color: ", ";\n      }\n    }\n  }\n\n  &.disabled {\n    input.name {\n      color: ", ";\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    button:disabled {\n      background: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n  }\n\n  &.invalid {\n    input.name {\n      background: ", ";\n      border: 1.5px solid ", ";\n      color: ", ";\n    }\n\n    button {\n      background: ", ";\n      border: 1.5px solid ", ";\n      /* color: ", ";\n      background: ", ";\n      color: ", ";\n      cursor: not-allowed; */\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map